import { RootState } from "infrastructure/store";
import {  convertToOptions } from "util/transformers";

export const selectLegalFormOptions = (state: RootState) => {
    const data = state.general.constants.OnboardingLegalForms ?? [];
    return convertToOptions(
        data ?? {},
    );

};